import React from 'react';
export const { APP_ENV, SITE_HOST, REACT_APP_DRUPAL_API_ENDPOINT, SPOT_ID_QA, SPOT_ID_PROD } = process.env;
export const FORWARD = 'forward';
export const TERMS = 'terms';
export const PRIVACY_POLICY = 'privacy-policy';
export const EDITORIAL_POLICY = 'editorial-policy';
export const CONTEST_RULES = 'contest-rules';
export const PRIVACY = 'privacy';
export const AUTHOR_IMAGE_PLACEHOLDER = 'https://www.purewow.com/static-gmg/purewow/logos/pw-placeholder-editor-image.webp';
export const SOCIAL_SHARE_IMAGE_DEFAULT = 'https://www.purewow.com/static-gmg/purewow/logos/pw-placeholder-editor-image.webp';
export const AFFILIATE_URLS = ['go.skimresources.com', 'go.redirectingat.com', 'shop-links.co', 'shop-edits.co', 'howl.me', 'www.amazon.com', 'click.linksynergy.com', 'goto.walmart.com', 'qvc.uikc.net', 'www.awin1.com', 'www.pjatr.com', 'www.dpbolvw.net', 'shareasale.com', 'prf.hn', 'go.linkby.com', 'www.kayak.com', 'amzn.to', 'fave.co/2W7ltOB', 'airbnb.pvxt.net', 'walmart.com', 'tkqlhce.com', 'kqzyfj.com', 'nordstrom.sjv.io', 'howl.link', 'anrdoezrs.net'];
export const INTERNAL_URLS = [
  'purewow.com',
  'one37pm.com',
  'purewow.net',
  'one37pm.net',
  'gallerymediagroup.com',
  'podcasts.gallerymediagroup.com',
];
export const SOCIALS_MAP = {
  instagram: {
    href: 'https://www.instagram.com/purewow/',
    className: 'icon-instagram',
    icon: (<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="25" width="25" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>),
  },
  podcast: {
    href: 'https://podcasts.gallerymediagroup.com/',
    className: 'icon-podcast-icon',
  },
  pinterest: {
    href: 'https://pinterest.com/purewow',
    className: 'icon-pinterest',
    icon: (<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 384 512" height="21" width="21" xmlns="http://www.w3.org/2000/svg"><path d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"></path></svg>),
  },
  twitter: {
    href: 'https://twitter.com/purewow',
    className: 'icon-twitter',
  },
  facebook: {
    href: 'https://www.facebook.com/PureWow/',
    className: 'icon-facebook',
    icon: (<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="21" width="21" xmlns="http://www.w3.org/2000/svg"><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path></svg>),
  },
  youtube: {
    href: 'https://www.youtube.com/user/PureWowVideos',
    className: 'icon-youtube',
    icon: (<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="25" width="25" xmlns="http://www.w3.org/2000/svg"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>),
  },
  tiktok: {
    href: 'https://www.tiktok.com/@purewow?',
    className: 'icon-tiktok',
    icon: (<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="21" width="21" xmlns="http://www.w3.org/2000/svg"><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path></svg>),
  },
};
export const PODCASTS_MAP = {
  profile: {
    url: 'https://podcasts.gallerymediagroup.com/',
    image: 'https://www.purewow.com/static-gmg/one37pm/logos/137FM-logo.png',
    alt: '137FM Podcast',
  },
};
export const SLUGS_MAP = {
  "purewow100reviews": {
    url: '/fashion/purewow-100-guide',
    text: 'purewow100',
    className: 'tag-purewow',
  },
  "selfcare": {
    url: '/wellness/self-care',
    text: 'self-care',
    className: 'tag-selfcare',
  },
  "self-care": {
    url: '/wellness/self-care',
    text: 'self-care',
    className: 'tag-selfcare',
  },
  "royally-obsessed": {
    url: 'https://podcasts.apple.com/us/podcast/royally-obsessed/id1365334446?mt=2&at=1010lLxU&ct=onsite_logo_bug_RO',
    text: 'Royally Obsessed',
    className: 'tag-royallyobsessed',
  },
  "royal-family": {
    url: 'https://podcasts.apple.com/us/podcast/royally-obsessed/id1365334446?mt=2&at=1010lLxU&ct=onsite_logo_bug_RO',
    text: 'Royally Obsessed',
    className: 'tag-royalfamily',
  },
  "chicago": {
    url: '/chicago',
    text: 'Chicago',
    className: 'tag-chicago',
  },
  "dallas": {
    url: '/dallas',
    text: 'Dallas',
    className: 'tag-dallas',
  },
  "hamptons": {
    url: '/hamptons',
    text: 'Hamptons',
    className: 'tag-hamptons',
  },
  "los-angeles": {
    url: '/la',
    text: 'Los Angeles',
    className: 'tag-la',
  },
  "la": {
    url: '/la',
    text: 'Los Angeles',
    className: 'tag-la',
  },
  "miami": {
    url: '/miami',
    text: 'Miami',
    className: 'tag-miami',
  },
  "new-york": {
    url: '/ny',
    text: 'New York',
    className: 'tag-ny',
  },
  "ny": {
    url: '/ny',
    text: 'New York',
    className: 'tag-ny',
  },
  "san-francisco": {
    url: '/sf',
    text: 'San Francisco',
    className: 'tag-sf',
  },
  "sf": {
    url: '/sf',
    text: 'San Francisco',
    className: 'tag-sf',
  },
};
export const HOMEPAGE_MAP = ['latest', 'ourPicks', 'beauty', 'wellness', 'food', 'family', 'fashion', 'more'];
export const HOMEPAGE_VERTICAL_MAP = ['latest', 'ourPicks', 'popular', 'beauty', 'wellness', 'food', 'family', 'fashion', 'entertainment'];
export const BYLINE_STICKY_ON = false;
export const FOOTER_VERTICALS = ['style', 'food', 'family', 'wellness'];

